(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["early-access-gate"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-early-access-form]');

    if (!trigger) return;

    const formId = trigger.dataset.earlyAccessForm;

    if (!formId) return;

    event.preventDefault();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gift-card-recipient-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const NAME = 'gift-card-recipient-form';

    if (customElements.get(NAME)) return;

    class GiftCardRecipientForm extends HTMLElement {
      #abort = null;
      #toggle = null;
      #fields = null;
      #controls = [];
      #email = null;

      connectedCallback() {
        this.#toggle = this.querySelector('[data-recipient-toggle]');
        this.#fields = this.querySelector('[data-recipient-fields]');
        if (!this.#toggle || !this.#fields) return;

        this.#controls = [...this.#fields.querySelectorAll('input, textarea')];
        this.#email = this.#fields.querySelector('input[type="email"]');

        this.#abort = new AbortController();
        const { signal } = this.#abort;

        this.#toggle.addEventListener('change', () => this.#sync(), {
          signal,
        });

        // A back or forward visit that misses the bfcache restores the ticked
        // box after this element has synced, and fires no change event, so the
        // fields would open while still disabled. Restoring is done by
        // `pageshow`, so sync again then.
        window.addEventListener('pageshow', () => this.#sync(), { signal });

        // The drawer names the form an add came from. After one succeeds the
        // next card starts unticked and empty, so a second gift cannot go to
        // the first recipient by accident. Not gated on the box: it may have
        // been unticked while the add was in flight, which would otherwise
        // leave the first recipient waiting in the folded fields.
        document.addEventListener(
          'cart:updated',
          (event) => {
            if (event.detail?.formId !== this.dataset.formId) return;

            this.#toggle.checked = false;
            for (const control of this.#controls) control.value = '';
            this.#sync();
          },
          { signal },
        );

        this.#sync();
      }

      disconnectedCallback() {
        this.#abort?.abort();
        this.#abort = null;
      }

      /**
       * Folded fields are disabled, so they leave the submission and the tab
       * order together. Their values are kept, so unticking by mistake and
       * ticking again loses nothing — a disabled control is never sent.
       */
      #sync() {
        const open = this.#toggle.checked;

        this.#fields.inert = !open;

        for (const control of this.#controls) {
          control.disabled = !open;
        }

        if (this.#email) this.#email.required = open;
      }
    }

    customElements.define(NAME, GiftCardRecipientForm);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["media-video-playback"] && !Shopify.designMode) return;
  try {
    (() => {
    const bindClickToPlay = (root = document) => {
      const wraps = root.querySelectorAll(
        '[data-media-video-playback="click"]:not([data-media-video-bound])',
      );

      for (const wrap of wraps) {
        wrap.dataset.mediaVideoBound = 'true';
        const video = wrap.querySelector('video');
        const playButton = wrap.querySelector('[data-media-video-play]');
        if (!video || !playButton) continue;

        const playVideo = () => {
          video.muted = false;
          const playPromise = video.play();
          wrap.classList.add('is-playing');
          playButton.hidden = true;

          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {
              wrap.classList.remove('is-playing');
              playButton.hidden = false;
            });
          }
        };

        playButton.addEventListener('click', (event) => {
          event.preventDefault();
          playVideo();
        });

        video.addEventListener('pause', () => {
          if (video.ended) return;
          wrap.classList.remove('is-playing');
          playButton.hidden = false;
        });

        video.addEventListener('ended', () => {
          wrap.classList.remove('is-playing');
          playButton.hidden = false;
        });
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => bindClickToPlay(), {
        once: true,
      });
    } else {
      bindClickToPlay();
    }

    document.addEventListener('shopify:section:load', (event) => {
      bindClickToPlay(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mini-product-tile"] && !Shopify.designMode) return;
  try {
    (() => {
    const COMPONENT_NAME = 'mini-product-tile';

    if (customElements.get(COMPONENT_NAME)) return;

    class MiniProductTile extends HTMLElement {
      #abortController = null;
      #toggle = null;
      #details = null;
      #dialog = null;
      #panel = null;
      #closeButton = null;
      #isClosing = false;
      #closing = null;
      #closeAnimationMs = 450;

      connectedCallback() {
        this.#abortController?.abort();
        this.#abortController = new AbortController();
        const { signal } = this.#abortController;

        this.#toggle = this.querySelector('.mini-product-tile__toggle');
        this.#details = this.querySelector('.mini-product-tile__details');
        this.#dialog = this.querySelector('[data-mini-product-tile-dialog]');
        this.#panel = this.querySelector('.mini-product-tile__panel');
        this.#closeButton = this.querySelector(
          '[data-mini-product-tile-close]',
        );

        this.#toggle?.addEventListener('click', this.#handleToggle, { signal });
        this.#closeButton?.addEventListener('click', this.#handleClose, {
          signal,
        });
        this.#dialog?.addEventListener('click', this.#handleDialogClick, {
          signal,
        });
        this.#dialog?.addEventListener('cancel', this.#handleDialogCancel, {
          signal,
        });
        this.#dialog?.addEventListener('close', this.#handleDialogClose, {
          signal,
        });
      }

      disconnectedCallback() {
        this.#abortController?.abort();
        this.#abortController = null;

        if (this.#isClosing) this.#finishDrawerClose();

        document.documentElement.classList.remove(
          'mini-product-tile-drawer-open',
        );
      }

      #setSingleOpen(isOpen) {
        this.classList.toggle('mini-product-tile--open', isOpen);
        this.#toggle?.setAttribute('aria-expanded', String(isOpen));
        this.#details?.setAttribute('aria-hidden', String(!isOpen));
      }

      #openDrawer() {
        if (!this.#dialog || this.#dialog.open || this.#isClosing) return;

        this.#dialog.classList.remove('mini-product-tile__dialog--active');
        this.#dialog.showModal();
        this.#toggle?.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('mini-product-tile-drawer-open');

        // The panel starts translated fully off-screen, so focusing inside it
        // scrolls the dialog's scroll box across even with preventScroll, which
        // reads as the drawer overshooting and settling back as it slides in.
        this.#closeButton?.focus({ preventScroll: true });
        this.#dialog.scrollLeft = 0;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.#dialog.classList.add('mini-product-tile__dialog--active');
          return;
        }

        // Two frames: the slide starts on the first frame the browser actually
        // paints after showModal(). WebKit re-resolves the whole document behind
        // the top layer promotion before it paints again, and a transition
        // started before that paint runs to completion unseen. See the colour
        // drawer for the recording that showed it.
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            if (!this.#dialog?.open || this.#isClosing) return;

            this.#dialog.classList.add('mini-product-tile__dialog--active');
          });
        });
      }

      #closeDrawer() {
        if (!this.#dialog?.open || this.#isClosing) return;

        this.#isClosing = true;
        this.#dialog.classList.remove('mini-product-tile__dialog--active');

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.#finishDrawerClose();
          return;
        }

        // The listener and the fallback both belong to this close only, and
        // whichever finishes it drops the other. A listener left behind would
        // catch the next open's slide-in and shut the drawer as it arrives.
        this.#closing = new AbortController();
        const { signal } = this.#closing;
        const timeoutId = window.setTimeout(
          () => this.#finishDrawerClose(),
          this.#closeAnimationMs + 50,
        );

        signal.addEventListener('abort', () => window.clearTimeout(timeoutId));

        this.#panel?.addEventListener(
          'transitionend',
          (event) => {
            if (event.target !== this.#panel) return;
            if (event.propertyName !== 'transform') return;

            this.#finishDrawerClose();
          },
          { signal },
        );
      }

      #finishDrawerClose() {
        this.#closing?.abort();
        this.#closing = null;

        if (this.#dialog?.open) this.#dialog.close();
        this.#isClosing = false;
      }

      #handleToggle = (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (this.#dialog) {
          this.#openDrawer();
          return;
        }

        this.#setSingleOpen(
          !this.classList.contains('mini-product-tile--open'),
        );
      };

      #handleClose = (event) => {
        event.preventDefault();
        this.#closeDrawer();
      };

      #handleDialogClick = (event) => {
        if (event.target === this.#dialog) this.#closeDrawer();
      };

      #handleDialogCancel = (event) => {
        event.preventDefault();
        this.#closeDrawer();
      };

      #handleDialogClose = () => {
        this.#dialog?.classList.remove('mini-product-tile__dialog--active');
        this.#toggle?.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove(
          'mini-product-tile-drawer-open',
        );

        if (this.#toggle?.isConnected) this.#toggle.focus();
      };
    }

    customElements.define(COMPONENT_NAME, MiniProductTile);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-badges"] && !Shopify.designMode) return;
  try {
    (() => {
    const NAME = 'product-dynamic-badges';

    class ProductDynamicBadges extends HTMLElement {
      #boundVariantChange = null;
      #variants = [];
      #lowStockThreshold = 5;
      #productAvailable = true;

      connectedCallback() {
        this.#lowStockThreshold = Number(this.dataset.lowStockThreshold || 5);
        this.#productAvailable = this.dataset.productAvailable !== 'false';

        try {
          this.#variants = JSON.parse(this.dataset.variants || '[]');
        } catch (error) {
          this.#variants = [];
        }

        this.#boundVariantChange = (event) => this.#onVariantChange(event);
        document.addEventListener('variant:change', this.#boundVariantChange);
        this.#syncFromSelectedVariant();
      }

      disconnectedCallback() {
        document.removeEventListener(
          'variant:change',
          this.#boundVariantChange,
        );
      }

      #staticBadges() {
        return [...this.children].filter(
          (child) =>
            !child.matches('[data-badge-sale], [data-badge-low-stock]'),
        );
      }

      #selectedVariant() {
        // Prefer product-form / product-card. The gallery overlay sits outside
        // the form, so fall back to the section. Do not use [data-product-id]:
        // that matches this host and misses the sibling form input.
        const scope =
          this.closest('product-form') ||
          this.closest('.product-card') ||
          this.closest('form') ||
          this.closest('.shopify-section');
        const variantInput = scope?.querySelector('[data-variant-input]');
        const selectedId = variantInput ? Number(variantInput.value) : null;

        if (selectedId) {
          const match = this.#variants.find(
            (item) => Number(item.id) === selectedId,
          );
          if (match) return match;
        }

        return this.#variants[0] || null;
      }

      #syncFromSelectedVariant() {
        const full = this.#selectedVariant();

        if (!full) return;

        const onSale =
          this.#productAvailable &&
          Number(full.compare_at_price) > Number(full.price);

        const inventoryQty = Number(full.inventory_quantity ?? 0);
        const lowStock =
          Boolean(full.available) &&
          Boolean(full.inventory_management) &&
          inventoryQty > 0 &&
          inventoryQty <= this.#lowStockThreshold;

        this.#applyBadgeVisibility(onSale, lowStock);
        this.#applySaleLabel(full.sale_percent);
      }

      #saleLabel(percent) {
        const value = Number(percent);

        if (Number.isFinite(value) && value > 0) {
          const template = this.dataset.saleLabel || '';

          if (template.includes('__PERCENT__')) {
            return template.replace('__PERCENT__', String(value));
          }
        }

        return this.dataset.saleFallback || '';
      }

      #applySaleLabel(percent) {
        const label = this.querySelector('[data-badge-sale] .product-badge');

        if (!label) return;

        label.textContent = this.#saleLabel(percent);
      }

      #applyBadgeVisibility(onSale, lowStock) {
        const limit = Number(this.dataset.badgeLimit || 2);
        const staticBadges = this.#staticBadges();

        for (const badge of staticBadges) {
          badge.hidden = false;
        }

        let used = staticBadges.filter((badge) => !badge.hidden).length;

        const saleNode = this.querySelector('[data-badge-sale]');
        const lowStockNode = this.querySelector('[data-badge-low-stock]');

        if (saleNode) {
          if (onSale) {
            if (used >= limit && staticBadges.length > 0) {
              staticBadges[staticBadges.length - 1].hidden = true;
              used -= 1;
            }

            saleNode.hidden = used >= limit;
            if (!saleNode.hidden) used += 1;
          } else {
            saleNode.hidden = true;
          }
        }

        if (lowStockNode) {
          if (lowStock) {
            if (used >= limit && staticBadges.length > 0) {
              const lastVisible = [...staticBadges]
                .reverse()
                .find((badge) => !badge.hidden);

              if (lastVisible) {
                lastVisible.hidden = true;
                used -= 1;
              }
            }

            lowStockNode.hidden = used >= limit;
          } else {
            lowStockNode.hidden = true;
          }
        }
      }

      #onVariantChange(event) {
        const variant = event.detail?.variant;
        const eventProductId = event.detail?.product?.id;

        if (!variant?.id) return;

        // Ignore variant changes from other products (carousel cards, etc.)
        if (
          this.dataset.productId &&
          eventProductId != null &&
          Number(eventProductId) !== Number(this.dataset.productId)
        ) {
          return;
        }

        const full = this.#variants.find(
          (item) => Number(item.id) === Number(variant.id),
        );

        // Do not fall back to a foreign variant payload
        if (!full) return;

        const onSale =
          this.#productAvailable &&
          Number(full.compare_at_price) > Number(full.price);

        const inventoryQty = Number(full.inventory_quantity ?? 0);
        const lowStock =
          Boolean(full.available) &&
          Boolean(full.inventory_management) &&
          inventoryQty > 0 &&
          inventoryQty <= this.#lowStockThreshold;

        this.#applyBadgeVisibility(onSale, lowStock);
        this.#applySaleLabel(full.sale_percent);
      }
    }

    if (!customElements.get(NAME)) {
      customElements.define(NAME, ProductDynamicBadges);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-buy-buttons"] && !Shopify.designMode) return;
  try {
    /* Klaviyo owns the modal, the list and the validation — the theme only opens
     the merchant's chosen form and tells Klaviyo which variant it is for. */
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-notify-trigger]');

    if (!trigger) return;

    const formId = trigger.dataset.klaviyoFormId;

    if (!formId) return;

    event.preventDefault();

    window.__rokaNotifyContext = {
      variantId: trigger.dataset.variantId || null,
    };

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-complementary"] && !Shopify.designMode) return;
  try {
    /*
   * Mobile pagination for the Perfect Hue carousel. The list is a plain
   * scroll-snap row, so the indicator is derived from scroll position rather
   * than a carousel library. Panels are filled lazily by
   * product-complementary.js, hence the MutationObserver rebuild.
   */
  (() => {
    const buildBullets = (pagination, count) => {
      if (pagination.childElementCount === count) return;

      pagination.replaceChildren();

      if (count < 2) return;

      for (let index = 0; index < count; index += 1) {
        const bullet = document.createElement('span');
        bullet.className = 'carousel-pagination__bullet';
        pagination.append(bullet);
      }
    };

    const syncActive = (list, pagination) => {
      const bullets = pagination.children;

      if (!bullets.length) return;

      const first = list.firstElementChild;
      const step = first ? first.getBoundingClientRect().width + 20 : 1;
      const index = Math.min(
        bullets.length - 1,
        Math.max(0, Math.round(list.scrollLeft / step)),
      );

      for (let i = 0; i < bullets.length; i += 1) {
        bullets[i].classList.toggle(
          'carousel-pagination__bullet--active',
          i === index,
        );
      }
    };

    const bind = (pagination) => {
      const panel = pagination.closest('[data-perfect-hue-panel]');
      const scope = panel || pagination.closest('product-complementary');
      const list = scope?.querySelector('[data-complementary-list]');

      if (!list || pagination.dataset.bound === 'true') return;

      pagination.dataset.bound = 'true';

      const refresh = () => {
        buildBullets(pagination, list.childElementCount);
        syncActive(list, pagination);
      };

      list.addEventListener('scroll', () => syncActive(list, pagination), {
        passive: true,
      });
      new MutationObserver(refresh).observe(list, { childList: true });
      refresh();
    };

    const bindAll = () => {
      for (const pagination of document.querySelectorAll(
        '[data-complementary-pagination]',
      )) {
        bind(pagination);
      }
    };

    bindAll();
    document.addEventListener('shopify:section:load', bindAll);
    document.addEventListener('colourway:change', bindAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
